import React from 'react'
import { Helmet } from 'react-helmet-async'
import { useInView } from 'react-intersection-observer'

import { Layout, Header } from 'app/theme/layout'
import LeadModal from 'app/leads/LeadModal'
import { useModalState } from 'lib/modal'
import NavbarFixed from 'app/theme/NavbarFixed'
import ImageHero from 'app/theme/ImageHero'
import { OccasionPageGrid, OccasionPageGridRow } from '../occasions/shared/OccasionPageGrid'
import CuisineTypes from 'app/theme/sections/CuisineTypes'
import HowItWorks from 'app/theme/sections/HowItWorks'
import HowItWorksLarge from 'app/theme/sections/HowItWorksLarge'
import WhyWorkWithUs from 'app/theme/sections/WhyWorkWithUs'
import Calculator from 'app/theme/calculator'

import heroImg from 'assets/img/jacksonville-catering-hero.jpg'
import gridImage1 from 'assets/img/jacksonville-catering-1.jpg'
import gridImage2 from 'assets/img/jacksonville-catering-2.jpg'

export default function JacksonvilleCateringPage() {
  const { openModal, ...modalState } = useModalState()

  const [ref, inView] = useInView({
    rootMargin: '1px',
    initialInView: true,
  })

  return (
    <Layout header={<Header occasionMenu />}>
      <Helmet>
        <title>Food Truck Catering - Jacksonville - Roaming Hunger - Roaming Hunger</title>
        <meta name="og:title" content="Food Truck Catering - Jacksonville - Roaming Hunger"></meta>
        <meta name="description" content="Book food truck catering in Jacksonville for your corporate event or private party."></meta>
      </Helmet>
      <LeadModal
        {...modalState}
      />
      <div ref={ref}>
        <ImageHero
          imageUrl={heroImg}
          title="Jacksonville Food Truck Catering"
          onButtonClick={openModal}
          description={(
            <div>
              Cater with Jacksonville's best local food trucks for your office, event or private party.
            </div>
          )}
        />
      </div>
      {!inView && (
        <NavbarFixed
          onButtonClick={openModal}
        />
      )}

      <OccasionPageGrid className="bg-white py-8">
        <OccasionPageGridRow
          heading="Make Everyone Happy"
          content="Choose from dozens of food trucks in Jacksonville and let guests customize individual orders during your event. No matter dietary requirements, every tastebud will be satisfied."
          image={gridImage1}
          reverse
        />
        <OccasionPageGridRow
          heading="Save Time"
          content="We negotiate the best rate, coordinate logistics, and make sure the food truck shows up with everything you need. That gives you more time to salivate over the menu."
          image={gridImage2}
        />
      </OccasionPageGrid>

      <Calculator
        heading="How Much Does Jacksonville Catering Cost?"
        onButtonClick={openModal}
      />

      <CuisineTypes baseUrl='/food-truck-catering' />

      <HowItWorks
        heading="How Jacksonville Catering Works"
        onButtonClick={openModal}
      />
      <HowItWorksLarge
        heading="How Jacksonville Catering Works"
        onButtonClick={openModal}
      />

      <WhyWorkWithUs
        onButtonClick={openModal}
      />
    </Layout>
  )
}
